import preVisitSection from "./preVisitState";
import preTravelSection from "./preTravelState";
import workerHomeSection from "./workerHomeState";

// Create the initial state for all 3 apps
const initialStore = {
  preVisit: preVisitSection,
  preTravel: preTravelSection,
  workerHome: workerHomeSection
};

export default initialStore;



// WEBPACK FOOTER //
// ./src/store/initialState/index.js